import React from 'react';
import { Navigate } from 'react-router-dom';
import {
  BTAFundingQuote,
  BusinessDetails,
  BusinessDirectorDetails,
  FinancialDetails,
  FundingApplicationDetails,
  FundingQuote,
  Home,
  IdentityVerification,
  LoanApplication,
  Login,
  Logout,
  PersonalDetails,
  ProductCatalogue,
  Profile,
  ProfileHome,
  Registration,
  SubmitApplication,
  BusinessList,
  BusinessVerification,
  LoanAccount,
  ApplyProduct,
  Accounts,
  MyApplication,
  Withdrawal
} from '../pages';

export const routes = {
  logout: {
    path: '/logout',
    element: <Logout />
  },
  demo: {
    path: '/demo',
    element: <Home />
  },
  login: {
    path: '/login',
    element: <Login />
  },
  registration: {
    path: '/registration',
    element: <Registration />
  },
  FundingApplicationDetails: {
    path: '/fundingApplicationDetails',
    element: <FundingApplicationDetails />
  },
  home: {
    path: '/',
    element: <LoanAccount />,
    children: [
      { index: true, element: <Navigate to="dashboard" replace /> },
      { path: 'dashboard', element: <ApplyProduct /> },
      { path: 'accounts/:applicationId', element: <Accounts /> },
      { path: 'applications/:businessId', element: <MyApplication /> },
      { path: 'quotes/:businessId', element: <BTAFundingQuote /> },
      { path: 'accounts/:businessId/withdrawal/:applicationId', element: <Withdrawal /> }
    ]
  },
  loanApplication: {
    path: '/apply',
    element: <LoanApplication />,
    children: [
      { path: '', element: null },
      { path: 'identityVerification', element: <IdentityVerification /> },
      { path: 'personalDetails', element: <PersonalDetails /> },
      { path: 'businessList', element: <BusinessList /> },
      { path: 'businessDetails', element: <BusinessDetails /> },
      { path: 'businessVerification', element: <BusinessVerification /> },
      { path: 'businessDirectors', element: <BusinessDirectorDetails /> },
      { path: 'financialDetails', element: <FinancialDetails /> }
    ]
  },
  submit: {
    path: '/submit',
    element: <SubmitApplication />
  },
  fundingQuote: {
    path: '/quote',
    element: <FundingQuote />,
    children: [
      { index: true, element: <BTAFundingQuote /> }
    ]
  },
  profile: {
    path: '/profile',
    element: <Profile />,
    children: [
      { path: '', element: <ProfileHome /> }
    ]
  },
  Products: {
    path: '/products',
    element: <ProductCatalogue />
  },
  default: {
    index: true,
    element: <ApplyProduct />
  }
};
